<template>
  <div class="assessment-result mb-3">
    <div class="label mb-2">{{ $t("feature.homecare.assessment_result") }}</div>
    <div v-if="job.rated_at">
      <div class="result">
        <div class="d-flex justify-content-between mb-3 align-items-center">
          <div class="score d-flex">
            <div class="user-score" :class="[scoreClass]">{{ job.score }}</div>
            <div class="info">
              <div class="text" :class="[scoreClass]">{{ scoreText }}</div>
              <div class="total">/ 10</div>
            </div>
          </div>
        </div>
        <div class="message mb-3">
          {{ job.note }}
        </div>
        <div class="date">
          {{ job.rated_at | moment-full }}
        </div>
      </div>
    </div>
    <div v-else class="pb-3">
      {{ $t("feature.homecare.no_assessment") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    job: {
      required: true
    }
  },
  computed: {
    scoreClass() {
      if (this.job.score > 6) {
        return "text-success";
      } else if (this.job.score > 4) {
        return "text-warning";
      }
      return "text-danger";
    },
    scoreText() {
      if (this.job.score > 8) {
        return this.$t("feature.homecare.assessment_text.excellent");
      } else if (this.job.score > 6) {
        return this.$t("feature.homecare.assessment_text.good");
      } else if (this.job.score > 4) {
        return this.$t("feature.homecare.assessment_text.satisfactory");
      }
      return this.$t("feature.homecare.assessment_text.needs_improvement");
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 11px;
  font-weight: 500;
  color: #8c8786;
}
.result {
  border-radius: 15px;
  background-color: #f9f9f9;
  padding: 16px;
}
.message {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
.date {
  color: #8c8786;
  font-size: 11px;
  font-weight: 500;
}
.score {
  .user-score {
    font-size: 36px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 0.75;
    letter-spacing: -0.2px;
    margin-right: 5px;
  }
  .info {
    line-height: 1.3;
    font-size: 11px;
  }
}
.no-score {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
.assessment-result {
  .text-success {
    color: #00b793 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/homecare/AssessmentResult.vue